import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    
    // Ensure modal is visible
    this.element.style.display = "block"
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  close() {
    this.element.classList.add("hidden")
    this.element.remove()
  }

  // Close modal when clicking outside
  closeOnOutsideClick(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }
}